import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import UserPanel from "./userPanel";
import FooterPanel from "./footerPanel";
import { MENUITEMS } from "../../../components/common/sidebar-component/menu";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import configDB from "../../../data/customizer/config";

const Sidebar = () => {
  const [margin, setMargin] = useState(0);
  const [width, setWidth] = useState(0);
  const [hideLeftArrowRTL, setHideLeftArrowRTL] = useState(true);
  const [hideRightArrowRTL, setHideRightArrowRTL] = useState(true);
  const [hideRightArrow, setHideRightArrow] = useState(true);
  const [hideLeftArrow, setHideLeftArrow] = useState(true);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false
  );

  const [mainmenu, setMainMenu] = useState({
    mainmenu: [...MENUITEMS],
  });

  const wrapper = configDB.data.settings.sidebar.wrapper;
  const layout = useSelector((content) => content.Customizer.layout);
  const { t } = useTranslation();
  const location = useLocation();

  const styles = {
    sidebarShell: {
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      background:
        "linear-gradient(180deg, #ffffff 0%, #f8fbff 48%, #eef6ff 100%)",
      borderRight: "1px solid #dbeafe",
      boxShadow: "14px 0 38px rgba(8, 27, 58, 0.07)",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },

    brandWrap: {
      flex: "0 0 auto",
      padding: "16px 16px 14px",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(248,251,255,0.92))",
      borderBottom: "1px solid #e6eef8",
    },

    brandLink: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      width: "100%",
      padding: "10px",
      borderRadius: 16,
      color: "#07172f",
      textDecoration: "none",
      background: "#ffffff",
      border: "1px solid #dbeafe",
      boxShadow: "0 10px 28px rgba(8, 27, 58, 0.06)",
    },

    logoMark: {
      width: 42,
      height: 42,
      flex: "0 0 42px",
      borderRadius: 14,
      display: "grid",
      placeItems: "center",
      color: "#ffffff",
      background: "linear-gradient(135deg, #07172f 0%, #0b4c9c 100%)",
      boxShadow: "0 12px 28px rgba(11, 76, 156, 0.20)",
      fontSize: 15,
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },

    brandTitle: {
      display: "block",
      color: "#07172f",
      fontSize: 15,
      fontWeight: 700,
      letterSpacing: "-0.01em",
      lineHeight: 1.15,
    },

    brandSub: {
      display: "block",
      marginTop: 4,
      color: "#64748b",
      fontSize: 11,
      fontWeight: 500,
      letterSpacing: "0",
      textTransform: "none",
    },

    sidebarInner: {
      background: "transparent",
      padding: "14px 14px 18px",
      flex: "1 1 auto",
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
    },

    userWrap: {
      marginBottom: 14,
      padding: 12,
      borderRadius: 20,
      background: "rgba(255,255,255,0.92)",
      border: "1px solid #dbeafe",
      boxShadow: "0 10px 26px rgba(8, 27, 58, 0.05)",
    },

    menu: {
      padding: "6px 0 14px",
      listStyle: "none",
    },

    menuItem: {
      margin: "5px 0",
      listStyle: "none",
    },

    sidebarTitle: {
      margin: "18px 12px 8px",
      color: "#94a3b8",
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
    },

    linkBase: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: 12,
      minHeight: 46,
      padding: "11px 14px",
      borderRadius: 14,
      color: "#475569",
      textDecoration: "none",
      background: "transparent",
      transition:
        "background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, transform 0.18s ease",
      border: "1px solid transparent",
      cursor: "pointer",
    },

    linkActive: {
      color: "#ffffff",
      background: "linear-gradient(135deg, #07172f 0%, #0b4c9c 100%)",
      boxShadow: "0 12px 30px rgba(11, 76, 156, 0.22)",
      border: "1px solid rgba(11, 76, 156, 0.18)",
    },

    activeRail: {
      position: "absolute",
      left: -14,
      top: 12,
      bottom: 12,
      width: 4,
      borderRadius: 999,
      background: "#c8a24a",
      boxShadow: "0 0 0 4px rgba(200, 162, 74, 0.12)",
    },

    iconWrap: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 23,
      height: 23,
      flex: "0 0 23px",
    },

    menuText: {
      flex: 1,
      minWidth: 0,
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: "0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    arrow: {
      marginLeft: "auto",
      color: "#94a3b8",
      transition: "transform 0.2s ease, color 0.2s ease",
      fontSize: 13,
    },

    arrowActive: {
      color: "#ffffff",
      transform: "rotate(90deg)",
    },

    submenu: {
      display: "none",
      margin: "8px 0 8px 20px",
      padding: "7px 0 7px 12px",
      borderLeft: "1px solid #dbeafe",
      listStyle: "none",
    },

    submenuOpen: {
      display: "block",
    },

    submenuLink: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      minHeight: 38,
      padding: "9px 12px",
      borderRadius: 12,
      color: "#64748b",
      textDecoration: "none",
      fontSize: 13,
      fontWeight: 400,
      letterSpacing: "0",
      transition:
        "background 0.18s ease, color 0.18s ease, transform 0.18s ease",
      cursor: "pointer",
    },

    submenuLinkActive: {
      color: "#0b4c9c",
      background: "#eef6ff",
      fontWeight: 600,
    },

    subDot: {
      width: 7,
      height: 7,
      borderRadius: 999,
      background: "#cbd5e1",
      flex: "0 0 7px",
    },

    subDotActive: {
      background: "#0b4c9c",
      boxShadow: "0 0 0 5px rgba(11, 76, 156, 0.13)",
    },

    footerWrap: {
      marginTop: 18,
      paddingTop: 14,
      borderTop: "1px solid #e5edf7",
    },

    arrowButton: {
      color: "#334155",
      background: "#ffffff",
      border: "1px solid #dbeafe",
      borderRadius: 999,
      cursor: "pointer",
      boxShadow: "0 8px 20px rgba(8, 27, 58, 0.08)",
    },
  };

  const closeMobileSidebar = () => {
    if (!isMobile) return;

    document.querySelector(".page-main-header")?.classList.remove("open");
    document.querySelector(".page-sidebar")?.classList.remove("open");
    document
      .querySelector(".page-body-wrapper")
      ?.classList.remove("sidebar-open");

    document.body.classList.remove("sidebar-open");
    document.body.classList.remove("offcanvas");
  };

  const fetchCustomAttendanceEnabled = () => {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      token: localStorage.getItem("token"),
    };

    return headers;
  };

  const updateMenuActiveState = (pathname) => {
    setMainMenu((prev) => {
      const clonedMenu = prev.mainmenu.map((item) => {
        const clonedItem = {
          ...item,
          active: false,
          children: item.children
            ? item.children.map((child) => ({
                ...child,
                active: false,
                children: child.children
                  ? child.children.map((subChild) => ({
                      ...subChild,
                      active: false,
                    }))
                  : undefined,
              }))
            : undefined,
        };

        if (clonedItem.path === pathname) {
          clonedItem.active = true;
        }

        if (clonedItem.children) {
          clonedItem.children = clonedItem.children.map((child) => {
            if (child.path === pathname) {
              clonedItem.active = true;
              return { ...child, active: true };
            }

            if (child.children) {
              const updatedSubChildren = child.children.map((subChild) => {
                if (subChild.path === pathname) {
                  clonedItem.active = true;
                  child.active = true;
                  return { ...subChild, active: true };
                }

                return subChild;
              });

              return {
                ...child,
                children: updatedSubChildren,
              };
            }

            return child;
          });
        }

        return clonedItem;
      });

      return { mainmenu: clonedMenu };
    });
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      setWidth(Math.max(window.innerWidth - 310, 0));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    const timeout = setTimeout(() => {
      const elmnt = document.getElementById("myDIV");

      if (!elmnt) return;

      const menuWidth = elmnt.offsetWidth;

      if (menuWidth > window.innerWidth) {
        setHideRightArrow(false);
        setHideLeftArrowRTL(false);
      } else {
        setHideRightArrow(true);
        setHideLeftArrowRTL(true);
      }
    }, 500);

    fetchCustomAttendanceEnabled();

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    updateMenuActiveState(location.pathname);
  }, [location.pathname]);

  const toggleNavActive = (item) => {
    if (item.type === "link") closeMobileSidebar();

    setMainMenu((prev) => {
      const updatedMenu = prev.mainmenu.map((menuItem) => {
        const isClickedMain = menuItem.title === item.title;

        if (menuItem.type === "sub" || menuItem.children) {
          return {
            ...menuItem,
            active: isClickedMain ? !menuItem.active : false,
          };
        }

        return {
          ...menuItem,
          active: isClickedMain,
        };
      });

      return { mainmenu: updatedMenu };
    });
  };

  const toggleChildActive = (parentItem, childItem) => {
    if (childItem.type === "link") closeMobileSidebar();

    setMainMenu((prev) => {
      const updatedMenu = prev.mainmenu.map((menuItem) => {
        if (menuItem.title !== parentItem.title) return menuItem;

        const updatedChildren = menuItem.children?.map((child) => ({
          ...child,
          active:
            child.title === childItem.title
              ? child.type === "sub"
                ? !child.active
                : true
              : false,
        }));

        return {
          ...menuItem,
          active: true,
          children: updatedChildren,
        };
      });

      return { mainmenu: updatedMenu };
    });
  };

  const scrollToRight = () => {
    const elmnt = document.getElementById("myDIV");
    if (!elmnt) return;

    const menuWidth = elmnt.offsetWidth;
    const temp = menuWidth + margin;

    if (temp < menuWidth) {
      setMargin(-temp);
      setHideRightArrow(true);
    } else {
      setMargin((current) => current - width);
      setHideLeftArrow(false);
    }
  };

  const scrollToLeft = () => {
    if (margin >= -width) {
      setMargin(0);
      setHideLeftArrow(true);
    } else {
      setMargin((current) => current + width);
      setHideRightArrow(false);
    }
  };

  const scrollToLeftRTL = () => {
    if (margin <= -width) {
      setMargin((current) => current - width);
      setHideLeftArrowRTL(true);
    } else {
      setMargin((current) => current - width);
      setHideRightArrowRTL(false);
    }
  };

  const scrollToRightRTL = () => {
    const temp = width + margin;

    if (temp === 0) {
      setMargin(temp);
      setHideRightArrowRTL(true);
    } else {
      setMargin((current) => current + width);
      setHideRightArrowRTL(false);
      setHideLeftArrowRTL(false);
    }
  };

  const getMenuStyle = () => {
    if (wrapper !== "horizontal_sidebar") {
      return {
        ...styles.menu,
        margin: "0px",
      };
    }

    if (layout === "rtl") {
      return {
        ...styles.menu,
        marginRight: `${margin}px`,
      };
    }

    return {
      ...styles.menu,
      marginLeft: `${margin}px`,
    };
  };

  const getLinkStyle = (active) => ({
    ...styles.linkBase,
    ...(active ? styles.linkActive : {}),
  });

  const getSubmenuStyle = (open) => ({
    ...styles.submenu,
    ...(open ? styles.submenuOpen : {}),
  });

  const getSubmenuLinkStyle = (active) => ({
    ...styles.submenuLink,
    ...(active ? styles.submenuLinkActive : {}),
  });

  const handleHoverIn = (e, active) => {
    if (active) return;

    e.currentTarget.style.background = "#ffffff";
    e.currentTarget.style.borderColor = "#dbeafe";
    e.currentTarget.style.boxShadow = "0 10px 26px rgba(8, 27, 58, 0.06)";
    e.currentTarget.style.color = "#07172f";
    e.currentTarget.style.transform = "translateX(2px)";
  };

  const handleHoverOut = (e, active) => {
    if (active) return;

    e.currentTarget.style.background = "transparent";
    e.currentTarget.style.borderColor = "transparent";
    e.currentTarget.style.boxShadow = "none";
    e.currentTarget.style.color = "#475569";
    e.currentTarget.style.transform = "translateX(0)";
  };

  return (
    <Fragment>
      <div className="page-sidebar" style={styles.sidebarShell}>
        <div
          className="main-header-left d-none d-lg-block"
          style={styles.brandWrap}
        >
          <Link to="/dashboard" style={styles.brandLink}>
            <div style={styles.logoMark} aria-label="SPGO.my">
              SP
            </div>

            <div>
              <strong style={styles.brandTitle}>SPGO.my</strong>
              <span style={styles.brandSub}>Government Portal</span>
            </div>
          </Link>
        </div>

        <div className="sidebar custom-scrollbar" style={styles.sidebarInner}>
          <div style={styles.userWrap}>
            <UserPanel />
          </div>

          <ul id="myDIV" className="sidebar-menu" style={getMenuStyle()}>
            <li
              className={`left-arrow ${
                layout === "rtl"
                  ? hideLeftArrowRTL
                    ? "d-none"
                    : ""
                  : hideLeftArrow
                  ? "d-none"
                  : ""
              }`}
              style={styles.arrowButton}
              onClick={
                wrapper === "horizontal_sidebar" && layout === "rtl"
                  ? scrollToLeftRTL
                  : scrollToLeft
              }
            >
              <i className="fa fa-angle-left" />
            </li>

            {mainmenu?.mainmenu?.map((menuItem, i) => {
              const Icon = menuItem.icon;
              const isActive = !!menuItem.active;

              return (
                <li
                  key={`${menuItem.title}-${i}`}
                  className={isActive ? "active" : ""}
                  style={styles.menuItem}
                >
                  {menuItem.sidebartitle ? (
                    <div style={styles.sidebarTitle}>
                      {t(menuItem.sidebartitle)}
                    </div>
                  ) : null}

                  {menuItem.type === "sub" ? (
                    <a
                      href="#"
                      className="sidebar-header"
                      style={getLinkStyle(isActive)}
                      onMouseEnter={(e) => handleHoverIn(e, isActive)}
                      onMouseLeave={(e) => handleHoverOut(e, isActive)}
                      onClick={(e) => {
                        e.preventDefault();
                        toggleNavActive(menuItem);
                      }}
                    >
                      {isActive && <span style={styles.activeRail} />}

                      <span style={styles.iconWrap}>
                        {Icon && <Icon size={19} strokeWidth={2.1} />}
                      </span>

                      <span style={styles.menuText}>{t(menuItem.title)}</span>

                      <i
                        className="fa fa-angle-right"
                        style={{
                          ...styles.arrow,
                          ...(isActive ? styles.arrowActive : {}),
                        }}
                      />
                    </a>
                  ) : null}

                  {menuItem.type === "link" ? (
                    <Link
                      to={menuItem.path}
                      className="sidebar-header"
                      style={getLinkStyle(isActive)}
                      onMouseEnter={(e) => handleHoverIn(e, isActive)}
                      onMouseLeave={(e) => handleHoverOut(e, isActive)}
                      onClick={() => toggleNavActive(menuItem)}
                    >
                      {isActive && <span style={styles.activeRail} />}

                      <span style={styles.iconWrap}>
                        {Icon && <Icon size={19} strokeWidth={2.1} />}
                      </span>

                      <span style={styles.menuText}>{t(menuItem.title)}</span>

                      {menuItem.children ? (
                        <i
                          className="fa fa-angle-right"
                          style={{
                            ...styles.arrow,
                            ...(isActive ? styles.arrowActive : {}),
                          }}
                        />
                      ) : null}
                    </Link>
                  ) : null}

                  {menuItem.children ? (
                    <ul
                      className={`sidebar-submenu ${
                        isActive ? "menu-open" : ""
                      }`}
                      style={getSubmenuStyle(isActive)}
                    >
                      {menuItem.children.map((childrenItem, index) => {
                        const canShow =
                          childrenItem.title !== "Portal User" ||
                          localStorage.getItem("role") === "1";

                        if (!canShow) return null;

                        const childActive = !!childrenItem.active;

                        return (
                          <li
                            key={`${childrenItem.title}-${index}`}
                            className={childActive ? "active" : ""}
                            style={{ listStyle: "none", margin: "3px 0" }}
                          >
                            {childrenItem.type === "sub" ? (
                              <a
                                href="#"
                                style={getSubmenuLinkStyle(childActive)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  toggleChildActive(menuItem, childrenItem);
                                }}
                              >
                                <span
                                  style={{
                                    ...styles.subDot,
                                    ...(childActive
                                      ? styles.subDotActive
                                      : {}),
                                  }}
                                />
                                <span>{t(childrenItem.title)}</span>
                                <i className="fa fa-angle-right pull-right" />
                              </a>
                            ) : null}

                            {childrenItem.type === "link" ? (
                              <Link
                                to={childrenItem.path}
                                style={getSubmenuLinkStyle(childActive)}
                                onClick={() =>
                                  toggleChildActive(menuItem, childrenItem)
                                }
                              >
                                <span
                                  style={{
                                    ...styles.subDot,
                                    ...(childActive
                                      ? styles.subDotActive
                                      : {}),
                                  }}
                                />
                                <span>{t(childrenItem.title)}</span>
                              </Link>
                            ) : null}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </li>
              );
            })}

            <li
              className={`right-arrow ${
                layout === "rtl"
                  ? hideRightArrowRTL
                    ? "d-none"
                    : ""
                  : hideRightArrow
                  ? "d-none"
                  : ""
              }`}
              style={styles.arrowButton}
              onClick={
                wrapper === "horizontal_sidebar" && layout === "rtl"
                  ? scrollToRightRTL
                  : scrollToRight
              }
            >
              <i className="fa fa-angle-right" />
            </li>
          </ul>

          <div style={styles.footerWrap}>
            <FooterPanel />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Sidebar;